import { useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import OpenOrder, { OpenOrderRef } from './OpenOrder';
import OrderHistory from './OrderHistory';
import { useUserDetails } from '../../../../recoil/hooks/useUserState';
import Funds from './Funds';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';

type Tab = 'open-orders' | 'order-history' | 'trade-history' | 'funds';

export default function MyHistoryView({ isNotMobile = true }) {
  const [user, setUser] = useUserDetails();
  const isUserAuthenticated = user != null || false;
  const { market } = useParams<{ market: string }>();
  const [activeTab, setActiveTab] = useState<Tab>('open-orders');
  const [hideData, setHideData] = useState(false);

  // const handleModifyOrder = async (orderId: string, newPrice: string, newSize: string) => {
  //   try {
  //     await modifyOrder(orderId, {
  //       newPrice,
  //       newSize
  //     });
  //     await mutateOpenOrders();
  //     alert('Order modified successfully');
  //   } catch (error) {
  //     console.error('Error modifying order:', error);
  //     alert('Failed to modify order. Please try again.');
  //   }
  // };

  const Tabs = [
    { label: 'Open Orders', value: 'open-orders' },
    { label: 'Order History', value: 'order-history' },
    { label: 'Funds', value: 'funds' },
  ];

  const handleTabChange = (tab: Tab) => {
    setActiveTab(tab);
  };

  // Define the type for the ref to include openOrderLength
  const [orderLenght, setOrderLength] = useState(0);
  const [isCancellingAll, setIsCancellingAll] = useState(false);

  const openOrderRef = useRef<OpenOrderRef>(null);

  return (
    <div className="relative p-4  overflow-hidden  h-full rounded-lg bg-[#f1f1f1] dark:bg-cardColor text-[#121212] dark:!text-white">
      {/* Header with tabs and controls */}
      <div className="flex justify-between items-center mb-4">
        <div className="flex gap-4">
          {Tabs.map((tab) => (
            <div
              key={tab.value}
              className={`cursor-pointer text-[12px] pb-2 ${
                isNotMobile ? 'px-3' : 'px-0'
              } ${
                activeTab === tab.value
                  ? 'text-brand border-b-2 border-brand '
                  : 'text-gray-500 dark:hover:text-gray-300'
              } transition-colors duration-200`}
              onClick={() => handleTabChange(tab.value as Tab)}
            >
              {tab.label}
            </div>
          ))}
        </div>

        {isNotMobile && (
          <div className="flex items-center space-x-4">
            {activeTab === 'open-orders' && orderLenght > 0 ? (
              <button
                onClick={openOrderRef?.current?.handleCancelAllSymbolOrders}
                disabled={isCancellingAll}
                className="text-red text-xs px-3 py-1 rounded transition-colors duration-200 disabled:opacity-50"
                title="Cancel all open orders for this market"
              >
                {isCancellingAll ? 'Cancelling...' : 'Cancel All'}
              </button>
            ) : null}

            <label className="flex items-center space-x-1 text-xs gap-1 text-gray-400 cursor-pointer">
              <input
                type="checkbox"
                className="accent-yellow-500"
                checked={hideData}
                onChange={(e) => setHideData(e.target.checked)}
              />
              <span className="mt-[3px]">Hide data</span>
            </label>

            {activeTab === 'open-orders' && (
              <button
                onClick={() => openOrderRef?.current?.mutateOpenOrders?.()}
                className="bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-xs px-2 py-1 rounded transition-colors duration-200 flex items-center justify-center"
                title="Refresh open orders"
              >
                <FontAwesomeIcon
                  icon={faArrowsRotate}
                  className="scale-90 cursor-pointer"
                />
              </button>
            )}
          </div>
        )}
      </div>

      {/* Content area */}
      <div className="h-[calc(100%-20px)] overflow-hidden">
        {/* Open Orders Tab */}
        <OpenOrder
          ref={openOrderRef}
          hideData={hideData}
          market={market || ''}
          isActive={activeTab === 'open-orders'}
          setOrderLength={setOrderLength}
          setIsCancellingAll={setIsCancellingAll}
          isUserAuthenticated={isUserAuthenticated}
        />
        {/* Order History Tab */}
        <OrderHistory isActive={activeTab === 'order-history'} />
        {/* Funds Tab */}
        <Funds isActive={activeTab === 'funds'} />
      </div>
      {!isUserAuthenticated && (
        <div className="absolute inset-0 flex items-start justify-start rounded-lg">
          <div className="dark:bg-black/70 bg-black/10 backdrop-blur-sm flex items-center justify-center rounded-lg  h-[calc(100%-5px)] w-full">
            <div className="p-6 rounded-xl text-center">
              <svg
                className="w-[60px] h-[60px] text-gray-400 mx-auto mb-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                />
              </svg>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
